'use client'

import { useMemo } from 'react'

import { useMediaQuery } from 'styled-breakpoints/use-media-query'
import { useTheme } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { BreakpointsId } from 'Theme/Default/breakpoints'

export default function useResponsiveLayout() {
  const theme = useTheme()

  const breakpoints = useMemo(
    () => themeGet('styledBreakpoints')({ theme }),
    [theme],
  )

  const isMobile = useMediaQuery(breakpoints.down(BreakpointsId.Medium))

  const isTablet = useMediaQuery(
    breakpoints.between(BreakpointsId.Medium, BreakpointsId.Large),
  )

  const isDesktop = useMediaQuery(breakpoints.up(BreakpointsId.Large))

  const isWideDesktop = useMediaQuery(breakpoints.up(BreakpointsId.ExtraLarge))

  return {
    isDesktop,
    isMobile,
    isTablet,
    isWideDesktop,
  }
}
